import { getFlavorsByCategory } from 'utils/api/flavors.api';
import { useInfiniteQuery } from 'react-query';

function queryFn({ queryKey }) {
    return getFlavorsByCategory({
        category: queryKey[1].category,
        country: queryKey[1].country,
        dataSource: queryKey[1].dataSource,
        order_by: queryKey[1].order_by,
        ascending: queryKey[1].ascending,
        group: queryKey[1].group,
        search: queryKey[1].search,
        per_page: queryKey[1].per_page,
    });
}

export const getQueryKey = ({
    category,
    country,
    dataSource,
    order_by,
    ascending,
    group,
    search,
    per_page,
}) => {
    return [
        'flavors',
        {
            category,
            country,
            dataSource,
            order_by,
            ascending,
            group,
            search,
            per_page,
        },
    ];
};

const useFlavorsByCategory = ({
    per_page = 500,
    order_by,
    ascending,
    category,
    country,
    dataSource,
    group,
    search,
    enabled = true,
}) => {
    const queryKey = getQueryKey({
        order_by,
        ascending,
        category,
        country,
        dataSource,
        group,
        search,
        per_page,
    });
    const query = useInfiniteQuery(queryKey, queryFn, {
        enabled,
        staleTime: Infinity,
        getNextPageParam: (lastPage) => lastPage?.next_page ?? undefined,
        keepPreviousData: true,
    });
    const getQueryData = async () => {
        const currentPages = query?.data?.pages || [];
        const proms = [];
        for (
            let i = currentPages.length + 1;
            i <= query?.data?.pages[0]?.last_page;
            i++
        ) {
            proms.push(queryFn({ queryKey, pageParam: i }));
        }
        const restPages = await Promise.all(proms);
        return [...currentPages, ...restPages].map(({ data }) => data).flat();
    };
    return {
        query,
        queryKey,
        getQueryData,
    };
};

export default useFlavorsByCategory;
